/*
 * Cherry Pot - AJAX add-to-cart for product cards.
 *
 * PROBLEM THIS SOLVES
 * snippets/cp-card-extras.liquid renders a plain <form> POST to /cart/add for
 * single-variant products. That works without JavaScript, which is why it was
 * written that way - but it costs a full page reload, and the browser lands the
 * customer back at the top of the collection page. On mobile that reads as the
 * page "jumping", and it loses their scroll position in a 60-product grid.
 *
 * WHAT THIS DOES
 * Intercepts the submit, posts to /cart/add.js instead, and then dispatches the
 * theme's own `cart:update` event with the same detail shape Horizon's
 * product-form-component uses. Every existing listener - the cart bubble
 * (cart-icon.js), the drawer (cart-drawer.js auto-open), the drawer contents -
 * reacts exactly as it does for a native add. No new cart UI is invented here.
 *
 * PROGRESSIVE ENHANCEMENT IS PRESERVED
 * If this script fails to load, or fetch throws, the form falls back to its
 * original native POST. The customer still gets the item in their cart.
 */
(function () {
  'use strict';

  var BUSY = 'data-cp-adding';

  /** Section ids the cart UI needs re-rendered after an add. */
  function cartSectionIds() {
    var ids = [];
    var nodes = document.querySelectorAll(
      'cart-drawer-component, cart-items-component, cart-icon, [id^="shopify-section-"] .cart-drawer'
    );

    for (var i = 0; i < nodes.length; i++) {
      var section = nodes[i].closest('.shopify-section, [id^="shopify-section-"]');
      if (!section || !section.id) continue;
      var id = section.id.replace('shopify-section-', '');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }
    return ids;
  }

  function flash(button, ok) {
    if (!button) return;
    var original = button.getAttribute('data-cp-label') || button.textContent;
    button.setAttribute('data-cp-label', original);
    button.classList.add(ok ? 'cpcard-cta--done' : 'cpcard-cta--failed');
    setTimeout(function () {
      button.classList.remove('cpcard-cta--done', 'cpcard-cta--failed');
    }, 1400);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('cpcard-form')) return;
      if (form.hasAttribute(BUSY)) {
        event.preventDefault();
        return;
      }

      // Fetch is required. Without it, let the native POST happen.
      if (typeof window.fetch !== 'function' || typeof FormData !== 'function') return;

      event.preventDefault();
      form.setAttribute(BUSY, '');

      var button = form.querySelector('.cpcard-cta');
      if (button) button.disabled = true;

      var body = new FormData(form);
      // return_to is only meaningful for a full-page POST; drop it for the JSON API.
      body.delete('return_to');

      var sections = cartSectionIds();
      if (sections.length) body.set('sections', sections.join(','));

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) throw json;
            return json;
          });
        })
        .then(function (json) {
          var added = json.items ? json.items : [json];
          var count = 0;
          for (var i = 0; i < added.length; i++) count += added[i].quantity || 0;

          // Mirror Horizon's own contract. source: 'product-form-component'
          // tells cart-icon.js to INCREMENT the bubble rather than replace it,
          // which is the correct behaviour for an add.
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: json,
                sourceId: 'cp-card-add',
                data: {
                  source: 'product-form-component',
                  itemCount: count || 1,
                  variantId: added[0] && added[0].variant_id,
                  productId: added[0] && added[0].product_id,
                  sections: json.sections,
                },
              },
            })
          );

          flash(button, true);
        })
        .catch(function () {
          // Something went wrong server-side. Rather than leaving the customer
          // with a dead button, fall back to the native POST so the add still
          // completes - a reload is worse than a reload that never happens.
          flash(button, false);
          form.removeAttribute(BUSY);
          if (button) button.disabled = false;
          HTMLFormElement.prototype.submit.call(form);
        })
        .then(function () {
          form.removeAttribute(BUSY);
          if (button) button.disabled = false;
        });
    },
    // Capture, so this runs before any delegated theme handler.
    true
  );
})();
